"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWithBaseUrl = exports.stripUrl = exports.getWithSecureProtocol = exports.getWithProtocol = void 0;

var _startsWith2 = _interopRequireDefault(require("lodash/fp/startsWith"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getWithProtocol = function (url) {
  return (0, _startsWith2.default)('http')(url) ? url : "http://" + url;
};

exports.getWithProtocol = getWithProtocol;

var getWithSecureProtocol = function (url) {
  return (0, _startsWith2.default)('http')(url) ? url : "https://" + url;
};

exports.getWithSecureProtocol = getWithSecureProtocol;

var stripUrl = function (url) {
  return url.replace(/\/\/+/g, '/');
};

exports.stripUrl = stripUrl;

var getWithBaseUrl = function (url, baseUrl) {
  return baseUrl ? stripUrl("/" + baseUrl + "/" + url) : url;
};

exports.getWithBaseUrl = getWithBaseUrl;